/**
 * Detail view do plugin WhatsApp Cloud API com sub-abas.
 */

import React, { useState, useEffect } from 'react';
import {
  IconLayoutDashboard,
  IconHeartRateMonitor,
  IconTemplate,
  IconUserCircle,
  IconSettings,
} from '@tabler/icons-react';
import Overview from './Overview';
import Health from './Health';
import Templates from './Templates';
import Profile from './Profile';
import SettingsTab from './Settings';
import './detail.css';

const SUB_TABS = [
  { id: 'overview', name: 'Visão Geral', icon: IconLayoutDashboard, component: Overview },
  { id: 'health', name: 'Saúde', icon: IconHeartRateMonitor, component: Health },
  { id: 'templates', name: 'Templates', icon: IconTemplate, component: Templates },
  { id: 'profile', name: 'Perfil', icon: IconUserCircle, component: Profile },
  { id: 'settings', name: 'Configurações', icon: IconSettings, component: SettingsTab },
];

const CloudApiDetail = ({ agentId, navigation, onAlertCTA }) => {
  const [activeSubTab, setActiveSubTab] = useState('overview');

  // Quando AlertsContext pede sub-section específica, navega.
  // Depende SOMENTE de pendingSubSection — não do objeto navigation inteiro
  // que é recriado a cada render do parent.
  const pendingSubSection = navigation?.pendingSubSection;
  const clearPendingSubSection = navigation?.clearPendingSubSection;
  useEffect(() => {
    if (pendingSubSection) {
      const target = SUB_TABS.find((t) => t.id === pendingSubSection);
      if (target) {
        setActiveSubTab(target.id);
        clearPendingSubSection?.();
      }
    }
  }, [pendingSubSection, clearPendingSubSection]);

  const ActiveComponent = SUB_TABS.find((t) => t.id === activeSubTab)?.component || Overview;

  return (
    <div className="cloudapi-detail">
      <nav className="cloudapi-detail__subtabs">
        {SUB_TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              type="button"
              className={`cloudapi-detail__subtab ${activeSubTab === tab.id ? 'cloudapi-detail__subtab--active' : ''}`}
              onClick={() => setActiveSubTab(tab.id)}
            >
              <Icon size={14} />
              {tab.name}
            </button>
          );
        })}
      </nav>

      <div className="cloudapi-detail__content">
        <ActiveComponent
          agentId={agentId}
          navigation={navigation}
          onAlertCTA={onAlertCTA}
          switchTab={setActiveSubTab}
        />
      </div>
    </div>
  );
};

export default CloudApiDetail;
